<div id="wrapper">
  <div class="vertical-align-wrap">
    <div class="vertical-align-middle auth-main">
      <div class="auth-box">
        <div class="top text-white font-weight-bold">
          <img src="../assets/images/logo/ridereg_logo-white.png" alt="RideReg" class="img-responsive logo">
        </div>
        <div class="card">
          <div class="header">
            <p class="lead">Reset Account Password</p>
          </div>
          <div class="body">
            <form class="form-auth-small" #setPasswordForm="ngForm" (ngSubmit)="resetPassword()">
              <div class="form-group">
                <input class="form-control" placeholder="Enter Password" type="password"
                       #password="ngModel" minlength="4" id="password"
                       [(ngModel)]="credentials.password" [ngModelOptions]="{standalone: true}" required>
                <div class="text-danger"  *ngIf="password.errors && (password.dirty || password.touched)">
                  <span class="validation-message" [hidden]="!password.hasError('minlength')">
                 Invalid password</span>
                  <span class="validation-message" [hidden]="!password.hasError('required')">
                 Password is required</span>
                </div>
              </div>
              <div class="form-group">

                <input class="form-control" placeholder="Confirm Password..." type="password"
                       #reenterPassword="ngModel" minlength="4" id="reenterPassword"
                       [(ngModel)]="credentials.password_confirmation" [ngModelOptions]="{standalone: true}" required>

                <div class="text-danger"  *ngIf="reenterPassword.errors && (reenterPassword.dirty || reenterPassword.touched)">
                  <span class="validation-message" [hidden]="!reenterPassword.hasError('minlength')">
                 Invalid Password</span>
                  <span class="validation-message" [hidden]="!reenterPassword.hasError('required')">
                 Password is required</span>
                </div>
              </div>
              <button type="submit" class="btn btn-primary btn-lg btn-block"
                      *ngIf="!loaders.login" [disabled]="password.errors || reenterPassword.errors">Reset Password</button>
              <span *ngIf="loaders.login" class="btn btn-primary btn-lg btn-block">Resetting&nbsp;<i class="fa fa-spin fa-spinner"></i></span >

              <div class="bottom">
                <span class="helper-text m-b-10"><i class="fa fa-lock"></i> &nbsp;<a [routerLink]="['/login']">Back to Login</a></span>
                <!--                <span>Don't have an account? <a href="page-register.html">Register</a></span>-->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
